import type { IconName } from "@luce/ui";

import { ChannelEnum, MasterNotificationCategoryEnum } from "../../__generated__/graphql";

export interface NotificationOption<TValue extends string> {
  value: TValue;
  label: string;
  icon: IconName;
  description?: string;
  /** Critical notifications — rendered on and locked. */
  alwaysOn?: boolean;
}

export const CHANNEL_OPTIONS: NotificationOption<ChannelEnum>[] = [
  { value: ChannelEnum.PushNotif, label: "Push Notification", icon: "Bell" },
  { value: ChannelEnum.Whatsapp, label: "WhatsApp", icon: "WhatsappLogo" },
  { value: ChannelEnum.Email, label: "Email", icon: "Envelope" },
];

export const CATEGORY_OPTIONS: NotificationOption<MasterNotificationCategoryEnum>[] = [
  {
    value: MasterNotificationCategoryEnum.VisitReminder,
    label: "Visit Reminder",
    icon: "MapPinArea",
    description:
      "Get timely updates about your bookings, service schedules, and follow-ups to keep you informed and prepared.",
  },
  {
    value: MasterNotificationCategoryEnum.PromoAndDiscount,
    label: "Promo and Discount",
    icon: "Gift",
    description:
      "Be the first to know about exclusive offers, discounts, and special promotions tailored just for you.",
  },
  {
    value: MasterNotificationCategoryEnum.Billing,
    label: "Billing Notification",
    icon: "Receipt",
    description:
      "Receive timely payment reminders, billing confirmations, and invoice updates to help you stay on top of your payments.",
    alwaysOn: true,
  },
];

export const CHANNELS_COPY = {
  title: "Notification Channels",
  description:
    "Choose how you want to receive updates. Critical notifications such as OTPs and invoices may still be sent regardless.",
};

export const CATEGORIES_COPY = {
  title: "Notification Categories",
  description:
    "Select the types of updates you care about. Manage what kind of messages you want to receive from us.",
};

export function toggleValue<TValue extends string>(
  values: TValue[],
  value: TValue,
  enabled: boolean,
): TValue[] {
  return enabled ? [...new Set([...values, value])] : values.filter((item) => item !== value);
}
